import { Document } from '@documents/models/document-type';

import { ReviewerDocumentPage } from '../types';

/**
 * How many pages are still owed after the first one.
 *
 * The reviewer-document endpoint returns `total` alongside every page, so the
 * first response is enough to know the rest. Returns 0 when the first page
 * already covers the total, or when `total` is absent.
 */
export function countRemainingReviewerDocumentPages(
  firstPage: ReviewerDocumentPage | undefined,
  pageSize: number,
): number {
  const loaded = firstPage?.data?.length ?? 0;
  const remaining = (firstPage?.total ?? 0) - loaded;
  return remaining > 0 ? Math.ceil(remaining / pageSize) : 0;
}

/**
 * Flattens reviewer-document pages into a single list, in page order.
 *
 * Lives here rather than in `ReviewerMaterialsService` so the data service
 * stays transport-only and this stays unit-testable on its own.
 */
export function flattenReviewerDocumentPages(
  pages: readonly (ReviewerDocumentPage | undefined)[],
): Document[] {
  const documents: Document[] = [];

  for (const page of pages) {
    if (!page?.data?.length) {
      continue;
    }
    for (const document of page.data) {
      documents.push(document);
    }
  }

  return documents;
}
